import Vue from "vue";

export function acceptMember(item) {
  return base({
    title: `${item.name} 님의 가입을 승인하시겠습니까?`,
    html: `
                <select id="swal-select" style="width: 100%; border: 1px solid #ccc; border-radius: 5px; padding: 10px;">
                  <option value="">-select-</option>
                  <option value="REGULAR">일반회원</option>
                  <option value="SPECIAL">명예회원</option>
                  <option value="ADMIN">관리자</option>
                </select>
            `,
    confirmButtonText: "가입 승인",
    cancelButtonText: "취소하기",
    icon: "question",
    preConfirm: () => {
      const selectValue = document.getElementById("swal-select").value;

      if (!selectValue) {
        Vue.prototype.$swal.showValidationMessage("회원 유형을 선택해 주세요.");
        return null;
      }

      return selectValue;
    },
  }).then((result) => {
    if (result.isConfirmed && result.value) {
      success();
      return result.value;
    }
    return null;
  });
}

export function deleteAdminRole() {
  return base({
    title: `어떤 권한을 제거하시겠습니까?`,
    html: `
              <div>
                <select id="swal-select" class="swal2-select">
                  <option value="">-select-</option>
                  <option value="member">회원 관리자</option>
                  <option value="editor">총평 관리자</option>
                  <option value="account">회계 관리자</option>
                  <option value="content">컨텐츠 관리자</option>
                  <option value="master">마스터 관리자</option>
                </select>
            `,
    confirmButtonText: "삭제하기",
    cancelButtonText: "취소하기",
    icon: "question",
    preConfirm: () => {
      const selectValue = document.getElementById("swal-select").value;

      if (!selectValue) {
        Vue.prototype.$swal.showValidationMessage("유형을 선택해 주세요.");
        return null;
      }

      return selectValue;
    },
  }).then((result) => {
    if (result.isConfirmed && result.value) {
      return result.value;
    }
    return null;
  });
}

export function addAdminRole(item) {
  return base({
    title: `어떤 권한을 추가하시겠습니까?`,
    html: `
              <div>
                <select id="swal-select" class="swal2-select">
                  <option value="">-select-</option>
                  <option value="member">회원 관리자</option>
                  <option value="editor">총평 관리자</option>
                  <option value="account">회계 관리자</option>
                  <option value="content">컨텐츠 관리자</option>
                  <option value="master">마스터 관리자</option>
                </select>
            `,
    confirmButtonText: "추가하기",
    cancelButtonText: "취소하기",
    icon: "question",
    preConfirm: () => {
      const selectValue = document.getElementById("swal-select").value;

      if (!selectValue) {
        Vue.prototype.$swal.showValidationMessage("유형을 선택해 주세요.");
        return null;
      }

      return selectValue;
    },
  }).then((result) => {
    if (result.isConfirmed && result.value) {
      return result.value;
    }
    return null;
  });
}

export function rejectMemberPopup(item) {
  return base({
    title: `${item.name} 님의 가입을 거절하시겠습니까?`,
    confirmButtonText: "가입 거절",
    cancelButtonText: "취소하기",
    icon: "warning",
  }).then((result) => {
    if (result.isConfirmed) {
      success();
      return true;
    }
    return false;
  });
}

export function deleteMemberPopup(item) {
  return base({
    title: `${item.name} 님을 탈퇴 시키겠습니까?`,
    confirmButtonText: "네",
    cancelButtonText: "취소하기",
    icon: "warning",
  }).then((result) => {
    if (result.isConfirmed) {
      success();
      return true;
    }
    return false;
  });
}

function base(descriptions) {
  return Vue.prototype.$swal.fire({
    title: descriptions.title,
    html: descriptions.html,
    confirmButtonText: descriptions.confirmButtonText,
    cancelButtonText: descriptions.cancelButtonText,
    icon: descriptions.icon,
    showCancelButton: true,
    confirmButtonClass: "md-button md-warning btn-fill",
    cancelButtonClass: "md-button md-danger btn-fill",
    confirmButtonColor: "orange",
    buttonsStyling: true,
    preConfirm: descriptions.preConfirm,
  });
}

export function success() {
  return Vue.prototype.$swal.fire({
    title: "완료하였습니다",
    icon: "success",
    iconColor: "orange",
    confirmButtonClass: "md-button md-success btn-fill",
    confirmButtonColor: "orange",
    buttonsStyling: true,
  });
}
